export default __webpack_public_path__ + "static/media/confusionImg_1.d14728f4.webp";